/*
 * @Description: 
 * @Author: wangying
 * @Date: 2021-10-26 14:36:37
 */
/*
 * @Author: Yangliwei
 * @Date: 2020-05-26 16:03:01
 * @LastEditTime: 2021-10-27 13:39:06
 * @LastEditors: Please set LastEditors
 * @FilePath: \teacher\src\config.js
 * @Just Think
 * @Description:
 */

const config = {
  baseurl: "https://gsc.see.org.cn/",
  // baseurl: "http://gsc.see.org.cn/",
  // title: "system.name",
  // successCode: 0,
  // vueXKey: "yangliwei-new-platform-mobile-teahcer",
  // AppID: "wx5d4a3f025c4c1026", //观山
  // AppSecret: "7140612cda953fdb1ce799bcd5b7b9cd",
  // linkurl: "http://qsgl.bzys.com.cn/teacher/#/login",
  // flag: "TEACHER_ACCOUNT"
};
// export default config;
module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js